// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"Q_TheComp__fLc3v"};